import React, { useState, useEffect } from "react";
import styles from "./CoreModules.module.css";
import { CircleMinus, CirclePlus } from "lucide-react";

interface CoreModulesProps {
  data: {
    id: number;
    title: string;
    sub_title: string;
    core_module_list: Array<{
      id: number;
      year_title: string;
      semesters: Array<{
        id: number;
        heading_text: string;
        credit_text: string;
        items: Array<{
          id: number;
          name: string;
          credits: string;
        }>;
      }>;
    }>;
  };
}

const CoreModules: React.FC<CoreModulesProps> = ({ data }) => {
  const [openYears, setOpenYears] = useState<boolean[]>([]);

  useEffect(() => {
    if (data && data.core_module_list) {
      setOpenYears(data.core_module_list.map((_, index) => index === 0));
    }
  }, [data]);

  if (!data || !data.core_module_list) {
    return null;
  }

  const toggleYear = (index: number) => {
    setOpenYears((prevOpenYears) => {
      const newOpenYears = [...prevOpenYears];
      newOpenYears[index] = !newOpenYears[index];
      return newOpenYears;
    });
  };
  const formatTitle = (text: string) => {
    return text?.split(/(\d+)/).map((part, index) => {
      const isNumber = /^\d+$/.test(part);
      return isNumber ? (
        <span key={index} className={styles.numberText}>
          {part}
        </span>
      ) : (
        <span key={index} className={styles.text}>
          {part}
        </span>
      );
    });
  };

  return (
    <div className={styles.coreModules}>
      <h2>{formatTitle(data.title)} </h2>
      <p>{data.sub_title}</p>
      {data.core_module_list.map((yearData, index) => (
        <div key={yearData.id}>
          <div className={styles.yearHeader} onClick={() => toggleYear(index)}>
            <h3>{formatTitle(yearData?.year_title)}</h3>
            {openYears[index] ? <CircleMinus /> : <CirclePlus />}
          </div>
          {openYears[index] && (
            <div className={styles.yearContent}>
              {yearData.semesters.map((semester) => (
                <div key={semester?.id} className={styles.semesterBlock}>
                  {(semester?.heading_text || semester?.credit_text) && (
                    <div className={styles.semesterHeader}>
                      <div>
                        <span className={styles.text}>
                          {semester?.heading_text?.replace(/\d+/g, "").trim()}
                        </span>
                        <span className={styles.number}>
                          {semester?.heading_text?.match(/\d+/)}
                        </span>
                      </div>
                      <span className={styles.Credits}>
                        {semester?.credit_text}
                      </span>
                    </div>
                  )}
                  <div className={styles.modulesList}>
                    {semester?.items.map((module) => (
                      <div key={module?.id} className={styles.moduleItem}>
                        <span>{module?.name}</span>
                        <span>{module?.credits}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CoreModules;
